import { User } from '@/graphql/generated/graphql';
import { FormControl, FormLabel, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { Fragment } from 'react';

interface UserDetailsProps {
  key: string;
  userInfo: Pick<User, 'firstName' | 'lastName' | 'email'> & { password: string };
  onFieldChange: (field: string, value: string) => void;
  showPassword?: boolean;
}

const UserDetails: React.FC<UserDetailsProps> = ({ key, userInfo, onFieldChange, showPassword = true }) => {
  return (
    <Fragment>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ flex: 1, minWidth: 140 }}>
          <FormLabel htmlFor="company-number" sx={{ fontSize: 12, mb: 0.5 }}>
            First Name
          </FormLabel>
          <TextField
            required
            fullWidth
            size="small"
            id={`${key}-first-name`}
            variant="outlined"
            value={userInfo.firstName}
            placeholder="e.g. John"
            onChange={(e) => onFieldChange('firstName', e.target.value)}
            error={userInfo.firstName.trim() === ''}
            helperText={userInfo.firstName.trim() === '' ? 'First Name is required' : ''}
          />
        </FormControl>
        <FormControl sx={{ flex: 1, minWidth: 140 }}>
          <FormLabel htmlFor="trading-name" sx={{ fontSize: 12, mb: 0.5 }}>
            Last Name
          </FormLabel>
          <TextField
            fullWidth
            size="small"
            id={`${key}-last-name`}
            variant="outlined"
            value={userInfo.lastName}
            placeholder="Smith"
            onChange={(e) => onFieldChange('lastName', e.target.value)}
          />
        </FormControl>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ flex: 1, minWidth: 140 }}>
          <FormLabel htmlFor="email" sx={{ fontSize: 12, mb: 0.5 }}>
            Email
          </FormLabel>
          <TextField
            id={`${key}-email`}
            required
            fullWidth
            size="small"
            variant="outlined"
            value={userInfo.email}
            placeholder="e.g. john@example.com"
            onChange={(e) => onFieldChange('email', e.target.value)}
            error={userInfo.email.trim() === ''}
            helperText={userInfo.email.trim() === '' ? 'Email is required' : ''}
          />
        </FormControl>
        {showPassword && (
          <FormControl sx={{ flex: 1, minWidth: 140 }}>
            <FormLabel htmlFor="password" sx={{ fontSize: 12, mb: 0.5 }}>
              Password
            </FormLabel>
            <TextField
              id={`${key}-password`}
              type="password"
              fullWidth
              size="small"
              variant="outlined"
              value={userInfo.password}
              onChange={(e) => onFieldChange('password', e.target.value)}
            />
          </FormControl>
        )}
      </Box>
    </Fragment>
  );
};

export default UserDetails;
